export const assistantSingleDictionary = {
  iStatus: 'Holati',
  iTeacherName: "O'qituvchi",
  startCreatedAt: 'Boshlangan sana',
  startEndedAt: 'Tuga(ydi)gan sana',
}
